import React from "react";
import applicationSubmittedStyle from "./application-submitted-widget.scss";
import { capitalise, toCurrency } from "@wisr/common";
import { amplitudeHelper } from "../../../../shared/analytics/analytics.utils";
import { BadgeComponent } from "../../../../shared/badge/badge.component";
import { WidgetComponent } from "../../../widget.component";
import { useGetSubmittedApplication } from "../../personal-loan/personal-loan-borrowing-widget.hooks";
import { useGetWisrProfile } from "../../../../redux/wisr-profile/wisr-profile.hooks";
import { BRAND_WEBSITE } from "../../../../shared/url.consts";

export const ApplicationSubmittedWidget: React.FC = () => {
  const user = useGetWisrProfile();
  const submittedApplicationDetails = useGetSubmittedApplication();

  React.useEffect(() => {
    if (submittedApplicationDetails) {
      amplitudeHelper.sendEvent("Viewed application submitted widget", {
        "Loan id": submittedApplicationDetails.id,
      });
    }
  }, [submittedApplicationDetails]);

  if (!submittedApplicationDetails) {
    return null;
  }

  return (
    <WidgetComponent widgetName="application-submitted" widgetType="other">
      <style jsx>{applicationSubmittedStyle}</style>
      <div className="application-submitted-widget">
        <div className="widget-title">
          <span>LOAN ID {submittedApplicationDetails.id}</span>
          <BadgeComponent badge="info">Received</BadgeComponent>
        </div>
        <p className="loan-details">
          {capitalise(submittedApplicationDetails.purpose)} &#8226;{" "}
          {toCurrency(submittedApplicationDetails.amount, false)}
        </p>
        <h3>We&rsquo;ve received your loan application</h3>
        <ul>
          <li>Term: {submittedApplicationDetails.term * 12} months</li>
          {!!submittedApplicationDetails?.estimatedRate &&
            !!submittedApplicationDetails?.estimatedMonthlyRepayment && (
              <>
                <li>
                  Estimated rate: {submittedApplicationDetails.estimatedRate}%
                </li>
                <li>
                  Estimated repayments:{" "}
                  {toCurrency(
                    submittedApplicationDetails.estimatedMonthlyRepayment,
                    false
                  )}{" "}
                  monthly
                </li>
              </>
            )}
        </ul>
        <p className="next-steps">Next steps</p>
        <p>
          Please check your email
          {user?.email && (
            <span>
              : <strong>{user.email}</strong>
            </span>
          )}{" "}
          for updates and next steps.
        </p>
        <p>
          If you&rsquo;d like to check on the progress please{" "}
          <a
            href={`${BRAND_WEBSITE}/contact-us?subject=Loans`}
            rel="noreferrer"
            target="_blank"
          >
            contact us
          </a>
          .
        </p>
      </div>
    </WidgetComponent>
  );
};
